import { isEqual } from 'lodash';

import { iaRa } from 'lib/helpers/utility';

export const doEmptyFormExist = ({ newForm = {}, forms = [] }) => {
  const copyForms = [...iaRa(forms)];

  return copyForms.some((row) => {
    const copyRow = { ...row };
    const copyNewForm = { ...newForm };

    delete copyRow?.id;
    delete copyNewForm?.id;

    return isEqual(copyRow, copyNewForm);
  });
};
